export default __webpack_public_path__ + "static/media/Moccasin_medium.072e0485.jpg";